var _defs, _path, _path2, _circle, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1920,
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 684.58,
    y1: 1448.12,
    x2: 1469,
    y2: 663.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ff5c35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ff653b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#ff7d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffa564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffa766"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180,940A387,387,0,1,1,727.3,392.7l780,780-409.72,409.72c-76,76-199.17,76-275.16,0Z",
    fill: "#ff5c35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.7,1172.7l780-780A387,387,0,1,1,1740,940l-642.42,642.42c-76,76-199.17,76-275.16,0Z",
    fill: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1466.35,
    cy: 666.35,
    r: 387,
    fill: "#ff5c35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1920,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/CustomerIcon.9f90f8a69a70f146085261e4b1066b3b.svg";
export { ForwardRef as ReactComponent };